import React from 'react';
import PropTypes from 'prop-types';

const Pending = ({ size, className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 72 72"
  >
    <rect width="72" height="72" fill="#E6F3FD" rx="36"></rect>
    <path
      fill="#008AEA"
      d="M34.904 42.793a7.884 7.884 0 0 0 11.638 6.94l3.112 3.113c.883.876 2.309.871 3.185-.01.878-.88.88-2.304.002-3.184l-3.11-3.11a7.888 7.888 0 1 0-14.827-3.749m16.74 8.05a.568.568 0 0 1-.396.969.57.57 0 0 1-.4-.166L47.95 48.75q.428-.371.8-.799zm-2.652-8.05a6.198 6.198 0 1 1-6.199-6.198 6.206 6.206 0 0 1 6.199 6.198M24.482 40a.845.845 0 0 0 0 1.69h5.373a.845.845 0 0 0 0-1.69zM25.077 34c-.595 0-1.077.379-1.077.845 0 .467.482.845 1.077.845h6.846c.595 0 1.077-.378 1.077-.845S32.518 34 31.923 34zM24.482 45a.845.845 0 0 0 0 1.69h5.373a.845.845 0 0 0 0-1.69zM40.123 29.845a.845.845 0 0 0-.845-.845H24.482a.845.845 0 0 0 0 1.69h14.796a.845.845 0 0 0 .845-.845M24.48 25.326h16.905a.845.845 0 0 0 0-1.691H24.48a.845.845 0 0 0 0 1.69"
    ></path>
    <path
      fill="#008AEA"
      d="M24.48 53.5h14.933a.845.845 0 0 0 0-1.69H24.48a4.795 4.795 0 0 1-4.79-4.79V24.48a4.795 4.795 0 0 1 4.79-4.79h16.905a4.796 4.796 0 0 1 4.79 4.79v8.79a.844.844 0 1 0 1.69 0v-8.79a6.49 6.49 0 0 0-6.48-6.48H24.48A6.49 6.49 0 0 0 18 24.48v22.54a6.49 6.49 0 0 0 6.48 6.48"
    ></path>
  </svg>
);

Pending.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

Pending.defaultProps = {
  size: 72,
  className: '',
};

export default Pending;
